import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import styles from "./Subtitle.module.styl";

function Subtitle({ children, size, color, className }) {
    const classes = cx(styles[`size_${size}`], styles[`color_${color}`], className);

    return <div className={classes}>{children}</div>;
}

Subtitle.propTypes = {
    size: PropTypes.oneOf(["subtitle-1", "subtitle-2", "subtitle-3"]).isRequired,
    color: PropTypes.oneOf(["dark-gray", "dark-blue"]).isRequired,
    className: PropTypes.string,
};

Subtitle.defaultProps = {
    size: "subtitle-1",
    color: "dark-gray",
};

export default Subtitle;
